import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  sl-dialog {
    --width: 900px;
  }

  .user-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .user-header h2 {
    margin: 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.5rem;
    font-weight: 600;
  }

  .user-role-badge {
    display: flex;
    align-items: center;
  }

  .error-message {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    background: var(--sl-color-danger-50);
    color: var(--sl-color-danger-700);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: var(--sl-border-radius-medium);
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
  }

  .user-fields {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .field-row {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .field-label {
    min-width: 140px;
    font-weight: 500;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
  }

  .field-value {
    flex: 1;
  }

  .field-value sl-input,
  .field-value sl-select,
  .field-value sl-checkbox {
    flex: 1;
    min-width: 200px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
  }

  .dialog-footer sl-button {
    min-width: 120px;
  }

  .permissions-section {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--sl-color-neutral-200);
  }

  .permissions-section h3 {
    margin: 0 0 1.5rem 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .permissions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1rem;
  }

  .permission-resource {
    background: var(--sl-color-neutral-50);
    border: 1px solid var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    padding: 1rem;
  }

  .resource-label {
    font-weight: 600;
    color: var(--sl-color-neutral-800);
    margin-bottom: 0.75rem;
    font-size: 0.875rem;
  }

  .permission-actions {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .permission-actions sl-checkbox {
    font-size: 0.875rem;
  }

  /* Responsive */
  @media (max-width: 768px) {
    sl-dialog {
      --width: 95vw;
    }

    .user-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .field-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .field-label {
      min-width: auto;
    }

    .field-value {
      width: 100%;
    }
  }
`;
